import { render, staticRenderFns } from "./GList.vue?vue&type=template&id=2e94378b&scoped=true&"
import script from "./GList.vue?vue&type=script&lang=js&"
export * from "./GList.vue?vue&type=script&lang=js&"
import style0 from "./GList.vue?vue&type=style&index=0&id=2e94378b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e94378b",
  null
  
)

export default component.exports